import { buyPolicyActionType } from 'src/actions/actionTypes'

const initialState = {
  title: '',
}

const buyPolicyTitleReducer = (state = initialState, action = {}) => {
  switch (action?.type) {
    case buyPolicyActionType.UPDATE_BUY_POLICY_TITLE:
      return { ...state, title: action.payload }
    default:
      return state
  }
}

export default buyPolicyTitleReducer
